var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { mapGetters } from 'vuex';
import { Component, Watch } from 'vue-property-decorator';
import VueDialog from "../../../../interface/IVueDialog";
import GoodService from '../../../../api/GoodService';
import CategoryService from '../../../../api/CategoryService';
import LeftTree from './LeftTree';
import TabTable from './TabTable.vue';
import LicenseBindGoodsTabTable from './tabTable/LicenseBindGoods';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var UpdateGoodsPrice = (function (_super) {
    __extends(UpdateGoodsPrice, _super);
    function UpdateGoodsPrice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.showSelected = false;
        _this.treeData = [];
        _this.tableData = [];
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {
            type: 1,
            price_base: 1,
            goods_format_ids: 1,
            ratio: '',
            added_money: '',
            price: '',
        };
        _this.dimension = 1;
        _this.showPriceBase = 1;
        _this.typeOptions = [
            {
                id: 1,
                label: "按增值比例"
            },
            {
                id: 2,
                label: "按增值金额"
            },
            {
                id: 3,
                label: "按固定价格"
            },
        ];
        _this.priceBaseOptions = [
            {
                id: 1,
                label: "货品档案含税参考价"
            },
            {
                id: 2,
                label: "库存成本单价"
            },
            {
                id: 3,
                label: "上次调价价格"
            },
            {
                id: 4,
                label: "当前页面销售价"
            },
        ];
        return _this;
    }
    UpdateGoodsPrice.prototype.watchType = function (newValue, oldValue) {
        console.log('type==>', newValue);
        if (newValue !== 3) {
            this.showPriceBase = 1;
        }
        else {
            this.showPriceBase = 0;
        }
    };
    UpdateGoodsPrice.prototype.watchPriceBase = function (newValue, oldValue) {
        console.log('price_base==>', newValue);
    };
    UpdateGoodsPrice.prototype.created = function () {
        console.log('1111111');
        this.service = GoodService.getInstance();
        this.categoryService = CategoryService.getInstance();
    };
    UpdateGoodsPrice.prototype.mounted = function () {
        if (this.is_erp == false) {
            this.priceBaseOptions = this.priceBaseOptions.filter(function (option) { return option.id !== 2; });
        }
    };
    UpdateGoodsPrice.prototype.close = function () {
        this.$closeDialog();
    };
    UpdateGoodsPrice.prototype.save = function () {
        console.log(12345, this.formData.type, this.formData.ratio, this.formData.added_money, this.formData.price);
        if (this.formData.type == 1 && (this.formData.ratio == null || this.formData.ratio == undefined || this.formData.ratio == '')) {
            this.$message.error('请输入调整比例');
            return;
        }
        else if (this.formData.type == 2 && (this.formData.added_money == null || this.formData.added_money == undefined || this.formData.added_money == '')) {
            this.$message.error('请输入调整金额');
            return;
        }
        else if (this.formData.type == 3 && (this.formData.price == null || this.formData.price == undefined || this.formData.price == '')) {
            this.$message.error('请输入调整金额');
            return;
        }
        this.$emit('save:ok', this.formData);
    };
    UpdateGoodsPrice.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
    };
    __decorate([
        Watch("formData.type")
    ], UpdateGoodsPrice.prototype, "watchType", null);
    __decorate([
        Watch("formData.price_base")
    ], UpdateGoodsPrice.prototype, "watchPriceBase", null);
    UpdateGoodsPrice = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable,
                'license-bind-goods-tab-table': LicenseBindGoodsTabTable
            },
            computed: __assign({}, mapGetters({
                isErp: 'isErp',
            })),
            directives: {
                numberFormat: {
                    bind: function (el, binding, vnode) {
                        var precision = parseInt(binding.value.precision) || 2;
                        var min = parseFloat(binding.value.min) || Number.MIN_SAFE_INTEGER;
                        var max = parseFloat(binding.value.max) || Number.MAX_SAFE_INTEGER;
                        var reg = new RegExp("^(-)?(\\d+)(\\.\\d{0," + precision + "})?(.*)?$");
                        var validReg = new RegExp("^(-)?(\\d+)(\\.\\d{0," + precision + "})?$");
                        var handler = function (event) {
                            var value = event.target.value;
                            value = value.replace(/[^\d.-]/g, '');
                            value = value.replace(reg, '$1$2$3');
                            var parts = value.split('.');
                            if (parts[1] && parts[1].length > precision) {
                                parts[1] = parts[1].slice(0, precision);
                                value = parts.join('.');
                            }
                            var numericValue = parseFloat(value);
                            numericValue = Math.min(Math.max(numericValue, min), max);
                            console.log('handler>>>', value, numericValue);
                            if (event.target.value === '-') {
                                return;
                            }
                            if (numericValue !== parseFloat(event.target.value) ||
                                event.target.value === '.' ||
                                !validReg.test(event.target.value)) {
                                var newVal = isNaN(numericValue) ? '' : numericValue;
                                vnode.data.model.callback(newVal);
                            }
                        };
                        el.addEventListener('input', handler);
                        console.log('el>>>', vnode);
                        vnode.context.$once('hook:beforeDestroy', function () {
                            el.removeEventListener('input', handler);
                        });
                    },
                }
            }
        })
    ], UpdateGoodsPrice);
    return UpdateGoodsPrice;
}(VueDialog));
export default UpdateGoodsPrice;
